import { z } from "zod/v4";

// biome-ignore format: we don't need the cards to take space
const TarotCardNameEnum = z.enum([
	"00-fool", "01-magician", "02-high-priestess", "03-empress", "04-emperor", "05-hierophant", "06-lovers", "07-chariot", "08-strength", "09-hermit", "10-wheel-of-fortune", "11-justice", "12-hanged-man", "13-death", "14-temperance", "15-devil", "16-tower", "17-star", "18-moon", "19-sun", "20-judgement", "21-world", "cups-ace", "cups-02", "cups-03", "cups-04", "cups-05", "cups-06", "cups-07", "cups-08", "cups-09", "cups-10", "cups-page", "cups-knight", "cups-queen", "cups-king", "pentacles-ace", "pentacles-02", "pentacles-03", "pentacles-04", "pentacles-05", "pentacles-06", "pentacles-07", "pentacles-08", "pentacles-09", "pentacles-10", "pentacles-page", "pentacles-knight", "pentacles-queen", "pentacles-king", "swords-ace", "swords-02", "swords-03", "swords-04", "swords-05", "swords-06", "swords-07", "swords-08", "swords-09", "swords-10", "swords-page", "swords-knight", "swords-queen", "swords-king", "wands-ace", "wands-02", "wands-03", "wands-04", "wands-05", "wands-06", "wands-07", "wands-08", "wands-09", "wands-10", "wands-page", "wands-knight", "wands-queen", "wands-king",
]);
export type TarotCardName = z.infer<typeof TarotCardNameEnum>;

const TAROT_ID_SEPARATOR = "::";

const TarotCardIdRegexp = new RegExp(
	`^[0-9a-zA-Z]+${TAROT_ID_SEPARATOR}(${TarotCardNameEnum.options.join("|")})$`,
);
const TarotCardIdSchema = z
	.string()
	.refine(
		(value) => TarotCardIdRegexp.test(value),
		"Wrong format of a card ID",
	);

export function createTarotCard(id: string, cardName: TarotCardName) {
	return TarotCardIdSchema.parse(`${id}${TAROT_ID_SEPARATOR}${cardName}`);
}

export const tarotCardIdToCardInfo = z.codec(
	TarotCardIdSchema,
	z.object({
		id: TarotCardIdSchema,
		name: TarotCardNameEnum,
	}),
	{
		encode(value) {
			return value.id;
		},
		decode(value) {
			return { id: value, name: value.split(TAROT_ID_SEPARATOR).at(1) as any };
		},
	},
);

const TarotDeckSchema_v1 = z.object({
	id: z.string(),
	v: z.undefined(),
});

const TarotDeckSchema_v2 = z.object({
	id: z.string(),
	v: z.literal(2),
	cards: z.tuple([TarotCardIdSchema, z.boolean()]).array(),
	createdAt: z.iso.datetime(),
	lastShuffled: z.iso.datetime().optional(),
});

export const TarotDeckSchema = z.discriminatedUnion("v", [
	TarotDeckSchema_v1,
	TarotDeckSchema_v2,
]);
export const TarotDeckSchema_latest = TarotDeckSchema_v2;

export const stringToTarotDeck = z.codec(z.string(), TarotDeckSchema, {
	encode(value) {
		return JSON.stringify(value);
	},
	decode(jsonString, ctx) {
		try {
			return JSON.parse(jsonString);
		} catch (err: unknown) {
			ctx.issues.push({
				code: "invalid_format",
				format: "json",
				input: jsonString,
				message: err && err instanceof Error ? err.message : String(err),
			});
			return z.NEVER;
		}
	},
});
